import { call, put } from 'redux-saga/effects';
import processError from '../../../utils/processError';
import { createEvacuationsFailed, createEvacuationsSuccessful } from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import makeRequest, { getBodyJson } from '../../../utils/makeRequest';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { CREATED } from '../../../configs/serverStatusCodes';
import { BACKEND_URL } from '../../../configs';

export default function* createEvacuations(action) {
  try {
    const url = `${BACKEND_URL}/evacuations`;
    const pool = action.payload;
    const response = yield makeRequest(url, pool, action, 'POST', true);
    if (response.status === CREATED) {
      const data = yield getBodyJson(response);
      yield put(createEvacuationsSuccessful());
      yield call(resolveActionPromise(action, data));
    } else {
      const data = yield getBodyJson(response);
      yield put(createEvacuationsFailed());
      yield call(rejectActionPromise(action, data));
    }
  } catch (e) {
    yield put(createEvacuationsFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
